import type { FunctionComponent } from 'react'
import { NullComponent } from '@ztechapps/webui.util'

export type Components = {
  topBar?: FunctionComponent
}

export const components: Components = {
  topBar: NullComponent,
}
